import { v4 as uuid } from 'uuid';

const key = 'shootsta-session-id-key';

const getSessionId = (): string => {
  const sessionId = sessionStorage.getItem(key);

  if (!sessionId) {
    const newSessionId = uuid();
    sessionStorage.setItem(key, newSessionId);
    return newSessionId;
  }
  return sessionId;
};

export default getSessionId;
